import GridLoadingSplash from './grid-loading-splash';

export default GridLoadingSplash;